import { render, staticRenderFns } from "./XCell.vue?vue&type=template&id=273c4c7c&lang=pug"
import script from "./XCell.vue?vue&type=script&lang=js"
export * from "./XCell.vue?vue&type=script&lang=js"
import style0 from "./XCell.vue?vue&type=style&index=0&id=273c4c7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VChip,VIcon,VSnackbar})
